import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutAccountContainerComponent } from '@spaq/core/layout/account/layout-account-container.component';
import { LayoutAccountContentComponent } from '@spaq/core/layout/account/layout-account-content/layout-account-content.component';
import { LayoutAccountFooterComponent } from '@spaq/core/layout/account/layout-account-footer';
import { LayoutAccountHeaderComponent } from '@spaq/core/layout/account/layout-account-header';
import { LayoutAccountMainComponent } from '@spaq/core/layout/account/layout-account-main';
import { LayoutAccountSidebarComponent } from '@spaq/core/layout/account/layout-account-sidebar';
import { LayoutAccountComponent } from '@spaq/core/layout/account/layout-account.component';
import { LayoutAuthContainerComponent } from '@spaq/core/layout/auth/layout-auth-container.component';
import { LayoutAuthHeaderComponent } from '@spaq/core/layout/auth/layout-auth-header';
import { LayoutAuthComponent } from '@spaq/core/layout/auth/layout-auth.component';
import { LayoutPageCardsComponent } from '@spaq/core/layout/pages/layout-page-cards';
import { LayoutPageDefaultComponent } from '@spaq/core/layout/pages/layout-page-default';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { PanelBarModule, LayoutModule } from '@progress/kendo-angular-layout';
import { BehaviorSubject } from 'rxjs';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';

export const LAYOUT_PAGE_TITLE = new InjectionToken<BehaviorSubject<string>>('');

@NgModule({
	declarations: [
		LayoutAuthComponent,
		LayoutAccountComponent,
		LayoutAccountContainerComponent,
		LayoutAuthContainerComponent,
		LayoutAccountHeaderComponent,
		LayoutAuthHeaderComponent,
		LayoutAccountFooterComponent,
		LayoutAccountSidebarComponent,
		LayoutAccountContentComponent,
		LayoutAccountMainComponent,
		LayoutPageDefaultComponent,
		LayoutPageCardsComponent
	],
	exports: [
		LayoutAuthComponent,
		LayoutAccountComponent,
		LayoutAccountContainerComponent,
		LayoutAuthContainerComponent,
		LayoutAccountHeaderComponent,
		LayoutAuthHeaderComponent,
		LayoutAccountFooterComponent,
		LayoutAccountSidebarComponent,
		LayoutAccountContentComponent,
		LayoutAccountMainComponent,
		LayoutPageDefaultComponent,
		LayoutPageCardsComponent
	],
	imports: [CommonModule, ButtonsModule, PanelBarModule, RouterModule, TranslateModule, LayoutModule, ComboBoxModule],
	providers: [
		{
			provide: LAYOUT_PAGE_TITLE,
			useValue: new BehaviorSubject('')
		}
	]
})
export class CoreLayoutModule {}
